import { render, staticRenderFns } from "./ConfirmRecordRefuse.vue?vue&type=template&id=dcfc8a7a&scoped=true"
import script from "./ConfirmRecordRefuse.vue?vue&type=script&lang=js"
export * from "./ConfirmRecordRefuse.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRecordRefuse.vue?vue&type=style&index=0&id=dcfc8a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfc8a7a",
  null
  
)

export default component.exports